import { render } from "./CreateWriteOff.vue?vue&type=template&id=259f4cd0&scoped=true&ts=true"
import script from "./CreateWriteOff.vue?vue&type=script&lang=ts"
export * from "./CreateWriteOff.vue?vue&type=script&lang=ts"

import "./CreateWriteOff.vue?vue&type=style&index=0&id=259f4cd0&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-259f4cd0"]])

export default __exports__